import { FormattedMessage } from 'react-intl';
import { DefaultUserMenu } from '@rio-cloud/rio-user-menu-component';
import ApplicationHeader from '@rio-cloud/rio-uikit/ApplicationHeader';
import IframeResizer from 'iframe-resizer-react';

import { config } from '../../config';

const AppHeader = () => {
    const environment = import.meta.env.PROD ? 'production' : 'local';

    const userMenuItem = <DefaultUserMenu environment={environment} disableCookieModal={true} />;

    return (
        <ApplicationHeader
            label={<FormattedMessage id='intl-msg:man-eula.moduleName' />}
            appNavigator={
                <IframeResizer title='Application menu' className='iFrameResizer' src={config.backend.MENU_SERVICE} />
            }
            // homeRoute={<Link to={config.homeRoute || ''} />}
            actionBarItems={[userMenuItem]}
        />
    );
};

export default AppHeader;
